import React, { useEffect } from 'react';

interface DrawerProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  widthClass?: string;
  // Cierra con Escape o al pulsar fuera del panel. Desactivado por defecto: un
  // clic accidental fuera no debe descartar un formulario a medio llenar.
  dismissible?: boolean;
}

const Drawer: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  children,
  title,
  widthClass = 'w-full md:w-1/3 lg:w-1/4',
  dismissible = false,
}) => {
  useEffect(() => {
    if (!isOpen || !dismissible) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, dismissible, onClose]);

  return (
    <div
      onClick={dismissible ? onClose : undefined}
      className={`fixed inset-0 z-50 bg-black  bg-opacity-70 transition-opacity p-4 flex justify-end ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
        className={`${widthClass} bg-white shadow-lg h-full overflow-y-auto transform transition-transform rounded-2xl ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex justify-between items-center p-4">
          <h2 className="text-2xl">{title}</h2>
          <button onClick={onClose} className="text-2xl" aria-label="Cerrar">
            &times;
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};
export default Drawer;
